import * as React from 'react';
import { Field, InjectedFormProps } from 'redux-form';
import { Col, HelpBlock, Row } from 'react-bootstrap';
import FieldFormControl from '../../../FieldFormControl';
import { isRequired } from '../../../../util/validators';
import { BsInfoCircle } from 'react-icons/bs';
import { get, isEmpty } from 'lodash';
import { FaExclamationTriangle } from 'react-icons/fa';

interface IChangeRenewalType extends InjectedFormProps {
  allowAutoRenewal: boolean;
  dispatch: any;
  change: any;
  renewalStatusValue: string;
  className?: string;
  synchronousError?: any;
  ignorePermissions: boolean;

  renderDefinition(name?: string, useProvidedString?: string): any;
}

export enum renewalTypeSelectionEnum {
  AUTO = 'auto',
  MANUAL = 'manual'
}

interface IChangeRenewalTypeState {
  showRenewalOptions: boolean,
}

class ChangeRenewalType extends React.Component<IChangeRenewalType, IChangeRenewalTypeState> {

  constructor(props) {
    super(props);
    props.change('renewalStatusChange', null)
  }

  public render() {
    const { allowAutoRenewal, renderDefinition, synchronousError, submitFailed, renewalStatusValue, ignorePermissions } = this.props;
    const hasError = !isEmpty(get(synchronousError, `renewalStatusChange`));

    return (
      <div className={'renewals-details-info'}>
        <div>
          <p><span className={'info-icon'}><BsInfoCircle/></span> Phew... well done on getting this far. By choosing
            auto-renewal you will be able to <b>save time</b> next year
            and ensure you are <b>continuously protected!</b></p>
        </div>
        <>
          <Row className="selection-your-renewal">
            <Col sm={12} className={'send-documents-box'} style={{ paddingBottom: '15px' }}>
              <div>
                <Row className="billing">
                  <Col xs={6} className={'radio-group margin-top'}>
                    <div className={'option no-border renewal-selection'}>
                      <div className="radio-button">
                        <Field
                          name={'renewalStatusChange'}
                          type="radio"
                          value={renewalTypeSelectionEnum.AUTO}
                          complexValue={true}
                          validationMessage={'single'}
                          component={FieldFormControl}
                          validate={[isRequired]}
                          disabled={!allowAutoRenewal && !ignorePermissions}
                        >
                          <div/>
                        </Field>
                      </div>
                      <div className="radio-text">
                          <span
                            style={!allowAutoRenewal && !ignorePermissions ? { opacity: '0.7' } : { opacity: '1' }}>{'Auto-renewal on'}</span>
                        {!allowAutoRenewal && !ignorePermissions ? renderDefinition('Renewal Type', 'We need to save your card details in order to auto-renew') : ''}
                      </div>
                    </div>
                  </Col>
                  <Col xs={6} className={'radio-group margin-top'}>
                    <div className={'option no-border renewal-selection'}>
                      <div className="radio-button">
                        <Field
                          name={'renewalStatusChange'}
                          type="radio"
                          value={renewalTypeSelectionEnum.MANUAL}
                          complexValue={true}
                          validationMessage={'single'}
                          component={FieldFormControl}
                          validate={[isRequired]}
                        >
                          <div/>
                        </Field>
                      </div>
                      <div className="radio-text">
                        {'Auto-renewal off'}
                      </div>
                    </div>
                  </Col>
                  <>
                    {renewalStatusValue === renewalTypeSelectionEnum.MANUAL && (
                      <div>
                        By removing the auto-renewal feature your cover will end on your renewal date, even if you are on
                        a trip. This could leave you without cover for emergency medical expenses or unable to make a
                        claim should you need to cancel or cut short your trip.
                      </div>
                    )}
                    {hasError && submitFailed && (
                      <div className={hasError ? 'has-error-red' : ''} style={{paddingLeft: '15px'}}>
                        <HelpBlock><FaExclamationTriangle/><span style={{marginLeft: '10px'}}>{'You must select how you would like your policy to renew next year before proceeding.'}</span></HelpBlock>
                      </div>
                    )}
                  </>
                </Row>
              </div>
            </Col>
          </Row>

          <div>To keep you protected your policy can be set to renew automatically using the payment details you
            provide. You can change your auto-renewal preference at any time for free during your policy term by
            contacting us by phone or online.
          </div>

          <div style={{ marginTop: '15px' }}>Before automatically renewing we will send you a renewal notice in
            advance so that you can review the
            new premium and cover details and have an opportunity to shop around. If you don't wish to accept the
            renewal offer at that time just let us know then and we can make sure no payment is taken.
          </div>
        </>
      </div>
    )
  }

}

export default ChangeRenewalType;
